/* "Find your rider type" chat. One question at a time: the workshop asks, the rider taps an answer, the next question
   slides in. Ends with the rider type and the bag we suggest. Nothing is sent anywhere.
   On this device only: "wng-rider" (the result, shared with the article quiz) and "wng-rider-invite" (invite closed). */
(function(){
  var root=document.getElementById('rider-chat'),R=window.WNGRider;if(!root||!R)return;
  var invite=document.getElementById('rc-invite'),panel=document.getElementById('rc-panel'),thread=document.getElementById('rc-thread'),
      answers=document.getElementById('rc-answers'),stepEl=document.getElementById('rc-step'),back=document.getElementById('rc-back'),
      loops=panel.querySelectorAll('.rc-loops li');
  var calm=window.matchMedia('(prefers-reduced-motion: reduce)').matches,small=window.matchMedia('(max-width:620px)');
  var prices={};try{prices=JSON.parse(document.getElementById('rc-prices').textContent)}catch(e){}
  var Q=R.QUESTIONS,a={},asked=[],said=[],resultNodes=[],timer=0,lastFocus=null;

  function get(k){try{return localStorage.getItem(k)}catch(e){return null}}
  function put(k,v){try{localStorage.setItem(k,v)}catch(e){}}
  function el(tag,cls,text){var e=document.createElement(tag);if(cls)e.className=cls;if(text)e.textContent=text;return e}
  function wait(ms,fn){clearTimeout(timer);timer=setTimeout(fn,calm?0:ms)}
  function toEnd(){thread.scrollTo({top:thread.scrollHeight,behavior:calm?'auto':'smooth'})}

  /* The invite: once per visitor, after about half the page, never on top of the product buy bar */
  function showInvite(){
    var bar=document.querySelector('.buybar:not([hidden])'),h=bar&&bar.offsetHeight?bar.offsetHeight:0;
    root.style.setProperty('--rc-lift',h+'px');invite.hidden=false;
    requestAnimationFrame(function(){invite.classList.add('in')});
  }
  function hideInvite(){invite.classList.remove('in');invite.hidden=true;put('wng-rider-invite','closed')}
  if(root.getAttribute('data-auto')==='1'&&!get('wng-rider')&&!get('wng-rider-invite')){
    var onScroll=function(){
      var room=document.documentElement.scrollHeight-innerHeight;
      if(room>300&&scrollY>Math.min(room*.45,1400)){removeEventListener('scroll',onScroll);showInvite()}
    };
    addEventListener('scroll',onScroll,{passive:true});
  }
  invite.querySelector('[data-rc-dismiss]').addEventListener('click',hideInvite);
  invite.querySelector('.rc-start').addEventListener('click',function(){hideInvite();open()});

  /* The panel: docked chat on wide screens, full screen sheet on phones */
  function open(){
    lastFocus=document.activeElement;
    if(small.matches){panel.showModal();document.documentElement.classList.add('rc-lock')}else panel.show();
    panel.classList.add('in');
    if(!asked.length&&!resultNodes.length)start();else focusAnswers();
  }
  function close(){
    panel.classList.remove('in');panel.close();document.documentElement.classList.remove('rc-lock');
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  panel.querySelector('[data-rc-close]').addEventListener('click',close);
  panel.addEventListener('keydown',function(e){if(e.key==='Escape'){e.preventDefault();close()}});
  panel.addEventListener('close',function(){document.documentElement.classList.remove('rc-lock')});
  document.addEventListener('click',function(e){
    var l=e.target.closest&&e.target.closest('a[href$="#rider-type"]');if(!l)return;
    e.preventDefault();if(!invite.hidden)hideInvite();open();
  });
  if(location.hash==='#rider-type')setTimeout(open,300);

  /* The conversation */
  function say(text,who,still){var m=el('li','rc-msg '+who);m.appendChild(el('p','',text));thread.appendChild(m);if(!still)toEnd();return m}
  function typing(then){
    var t=el('li','rc-msg bot rc-typing');t.setAttribute('aria-label','Typing');
    for(var i=0;i<3;i++)t.appendChild(el('span'));
    thread.appendChild(t);toEnd();
    wait(520,function(){t.remove();then()});
  }
  function progress(n){
    stepEl.textContent=n<Q.length?'Question '+(n+1)+' of '+Q.length:'Your result';
    for(var i=0;i<loops.length;i++)loops[i].classList.toggle('on',i<n);
    back.hidden=n===0;
  }
  function focusAnswers(){var b=answers.querySelector('button,a');if(b)b.focus({preventScroll:true})}
  function chips(n){
    answers.textContent='';answers.className='rc-answers';
    var g=el('div','rc-chips');g.setAttribute('role','group');g.setAttribute('aria-label',Q[n].text);
    Q[n].opts.forEach(function(o,i){
      var b=el('button','rc-chip',o[1]);b.type='button';b.style.setProperty('--i',i);
      b.addEventListener('click',function(){pick(n,o[0],o[1])});g.appendChild(b);
    });
    answers.appendChild(g);focusAnswers();
  }
  function ask(n){
    progress(n);answers.textContent='';
    typing(function(){asked[n]=say(Q[n].text,'bot');chips(n)});
  }
  function start(){
    thread.textContent='';a={};asked=[];said=[];resultNodes=[];
    say("Five quick questions. Tap an answer and we'll suggest the frame bag we would build for you.",'bot');
    ask(0);
  }
  function pick(n,val,label){
    a[Q[n].id]=val;said[n]=say(label,'me');answers.textContent='';
    if(n+1<Q.length)ask(n+1);else result();
  }
  back.addEventListener('click',function(){
    clearTimeout(timer);var t=thread.querySelector('.rc-typing');if(t)t.remove();
    resultNodes.forEach(function(x){x.remove()});resultNodes=[];
    var n=said.length;                       // answers given so far
    if(asked[n]){asked[n].remove();asked.length=n}
    n--;if(n<0)return;
    said[n].remove();said.length=n;delete a[Q[n].id];
    progress(n);chips(n);toEnd();
  });

  function result(){
    progress(Q.length);
    var r=R.recommend(a,prices),t=r.type;R.save(r);put('wng-rider-invite','closed');
    typing(function(){
      resultNodes.push(say("You're "+t.name+'.','bot',true));
      var li=el('li','rc-msg bot rc-result'),card=el('div','rc-card');
      var band=el('div','rc-band mat cw');['--c0','--c1','--c2'].forEach(function(v,i){band.style.setProperty(v,t.cols[i])});
      var tpl=document.getElementById('rc-tri-'+r.style);if(tpl)band.appendChild(tpl.content.cloneNode(true));
      card.appendChild(band);
      var body=el('div','rc-card-body');
      body.appendChild(el('h3','',t.name));body.appendChild(el('p','',t.line));
      var dl=el('dl','rc-rec');
      [['Your bag',r.sty.label+(r.price?', from $'+r.price+' CAD':'')],['Fabric',r.fab.label+'. '+r.fab.why]]
        .concat(r.feed?[['Add','The Raccoon feed bag, for a bottle or snacks within reach.']]:[])
        .forEach(function(p){dl.appendChild(el('dt','',p[0]));dl.appendChild(el('dd','',p[1]))});
      body.appendChild(dl);
      r.notes.concat(['Colours shown are an example. Pick your own in the bag maker.']).forEach(function(x){body.appendChild(el('p','rc-note',x))});
      card.appendChild(body);li.appendChild(card);thread.appendChild(li);resultNodes.push(li);
      var lead=resultNodes[0];setTimeout(function(){thread.scrollTo({top:lead.offsetTop-12,behavior:calm?'auto':'smooth'})},calm?0:80);
      answers.textContent='';answers.className='rc-answers done';
      var go=el('a','btn','Build this bag');go.href=root.getAttribute('data-maker')+'#'+r.style;answers.appendChild(go);
      var more=el('p','rc-more'),bag=el('a','','See the frame bag');bag.href=root.getAttribute('data-bag');more.appendChild(bag);
      if(r.feed){var f=el('a','','See The Raccoon');f.href=root.getAttribute('data-feed');more.appendChild(f)}
      var again=el('button','','Start again');again.type='button';again.addEventListener('click',start);more.appendChild(again);
      answers.appendChild(more);focusAnswers();
    });
  }
})();
